document.addEventListener('DOMContentLoaded', function () {
    const myModal = document.getElementById('myModal');
    if (myModal) {
        myModal.addEventListener('hidden.bs.modal', () => {
            const iframeYoutube = document.getElementById('iframeYoutube');
            if (iframeYoutube) {
                iframeYoutube.setAttribute('src', '#');
            }
        });
    }
});

function changeVideo(vId) {
    const iframe = document.getElementById('iframeYoutube');
    if (iframe)
        iframe.src = `https://www.youtube.com/embed/${vId}?autoplay=1`;
    bootstrap.Modal.getOrCreateInstance(document.getElementById('myModal')).show();
}